import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ProfileSidebarLeft from './ProfileSidebarLeft';

function ProfileLayout({ children }) {
  const location = useLocation();

  useEffect(() => {
    // Reset scroll position and ensure proper viewport height on mobile
    const resetScroll = () => {
      window.scrollTo(0, 0);
      // Set viewport height for mobile browsers
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };

    resetScroll();
    window.addEventListener('resize', resetScroll);
    window.addEventListener('orientationchange', resetScroll);

    return () => {
      window.removeEventListener('resize', resetScroll);
      window.removeEventListener('orientationchange', resetScroll);
    };
  }, [location.pathname]);

  return (
    <div className="container">
      <div className="row g-4 p-2 p-md-0">
        {/* Left sidebar (always visible) */}
        <div className="col-lg-3">
          <ProfileSidebarLeft />
        </div>

        {/* Right-side content changes depending on route */}
        <div className="col-lg-9">
          {children}
        </div>
      </div>
    </div>
  );
}

export default ProfileLayout;